module.exports = __webpack_public_path__ + "img/logoAppBarPrimary.564f76f3.svg";